// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);


    /**
     * Initializes the custom select dropdown functionality.
     * Handles initial state synchronization and click events for custom options.
     */
    function initializeCustomSelect() {
        const selectElement = document.getElementById("SellingPlan");
        const detailsElement = document.querySelector(".customDetails");
        if (!selectElement || !detailsElement) return;

        const summaryElement = detailsElement.querySelector("#selectedOption");
        const optionElements = detailsElement.querySelectorAll(".customOption");

        // Initialize based on current select value
        const initialOption = selectElement.options[selectElement.selectedIndex];
        const initialValue = initialOption ? initialOption.value : "";

        if (summaryElement) {
            summaryElement.firstElementChild.textContent = initialOption
                ? initialOption.textContent
                : "";
        }

        optionElements.forEach((option, index) => {
            const value = selectElement.options[index]?.value || "";
            option.setAttribute("data-value", value);
            option.classList.toggle("selected", value === initialValue);
        });

        // Add click handlers
        optionElements.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const text = option.textContent.trim();
                selectElement.value = value;
                if (summaryElement) {
                    summaryElement.firstElementChild.textContent = text;
                }
                optionElements.forEach((opt) => opt.classList.remove("selected"));
                option.classList.add("selected");
                detailsElement.removeAttribute("open");
            });
        });
    }

    /**
     * Handles the visibility and content of the product selling tag based on the selected option.
     */
    function handleOptionsEvents() {
        const tagElement = document.querySelector(".productSellingTag");
        const selectedCard = document.querySelector(
            ".productOptionItemValuesLabel:has(.productOptionItemValuesLabelInput:checked)"
        );
        if (!tagElement || !selectedCard) return;

        const headerElement = selectedCard.querySelector(
            ".productOptionItemValuesLabelBodyWrapInnerHeader"
        );
        const headerText = headerElement?.textContent?.trim() || "";
        tagElement.classList.toggle("hidden", !headerText);
        tagElement.textContent = headerText;
    }

    /**
     * Updates the savings display elements based on the active variant pricing.
     */
    function updateSavingsDisplay() {
        if (!activeVariant) return;

        const subSaveElement = document.querySelector(
            ".productSellingTagDiscountSub"
        );
        const oneTimeSaveElement = document.querySelector(
            ".productSellingTagDiscountOne"
        );
        if (!subSaveElement) return;

        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) return;

        const subTotal = activeVariant.compare_at_price
            ? activeVariant.compare_at_price - sellingPlanPrice
            : activeVariant.price - sellingPlanPrice;
        const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;

        const subSaveText = `SAVE ${price(subTotal, true)}`;
        subSaveElement.innerHTML = subSaveText;

        if (oneTimeSaveElement) {
            if (oneTimeTotal > 0) {
                const oneTimeSaveText = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSaveElement.innerHTML = oneTimeSaveText;
                oneTimeSaveElement.classList.remove("hidden");
            } else {
                oneTimeSaveElement.classList.add("hidden");
            }
        }
    }

    /**
     * Toggles the visibility of the one-time bottom content based on text presence.
     */
    function checkOneTimeTextVisibility() {
        const textElement = document.querySelector(
            ".productSellingLabelBodyBottomWrapContentTxt"
        );
        const bottomContentElement = document.querySelector(
            ".productSellingLabelBody.once .productSellingLabelBodyBottom"
        );
        if (!textElement || !bottomContentElement) return;

        const isEmpty = textElement.textContent.trim() === "";
        bottomContentElement.classList.toggle("hidden", isEmpty);
    }

    /**
     * Main initialization function for the B variant of the A/B test.
     * Calls all necessary setup functions.
     */
    function initializeMainEvent() {
        initializeCustomSelect();
        handleOptionsEvents();
        updateSavingsDisplay();
        checkOneTimeTextVisibility();
    }

    document.addEventListener("DOMContentLoaded", () => {
        initializeMainEvent();
    });
    window.addEventListener("load", () => {
        initializeMainEvent();
    });
    window.mainEvent = initializeMainEvent;

    document.addEventListener('mainProduct:update', initializeMainEvent)

}());